"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
require("./numberSelector.scss");
const displayWrapper_1 = require("./common/displayWrapper");
const hooks_1 = require("common/hooks");
const slider_1 = require("./common/slider");
const NumberSelectorSchemaComponent = (props) => {
    const { readOnly, schema } = props;
    const { textBefore, textCenter, textAfter, maxValue, minValue, naValue, naTitle, uiType, } = schema;
    const { registerProps: { onChange }, value, fieldState, } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const list = [...Array(maxValue - minValue + 1)].map((_, i) => i + minValue);
    const s = (0, hooks_1.useStringIntl)();
    const options = (0, react_1.useMemo)(() => {
        const options = [];
        if (minValue === undefined || maxValue === undefined)
            return options;
        const middleValue = Math.floor((maxValue - minValue) / 2) + minValue;
        for (let i = minValue; i <= maxValue; i++) {
            let title = i.toString();
            if (i === minValue)
                title = s(textBefore) || title;
            if (i === middleValue)
                title = s(textCenter) || title;
            if (i === maxValue)
                title = s(textAfter) || title;
            options.push({
                title,
                value: i,
            });
        }
        return options;
    }, [minValue, maxValue]);
    const sliderValue = (0, react_1.useMemo)(() => {
        // eslint-disable-next-line eqeqeq
        const index = options.findIndex((option) => option.value == value);
        return index === -1 ? undefined : index;
    }, [options, value]);
    const sliderOnChange = (0, react_1.useCallback)((index) => {
        const option = index != null ? options[index] : undefined;
        onChange(option === null || option === void 0 ? void 0 : option.value);
    }, [onChange, options]);
    const NotApplicableComponent = (0, react_1.useMemo)(() => {
        return naTitle ? (react_1.default.createElement("div", { className: "number-selector-except" },
            react_1.default.createElement("span", { className: (0, classnames_1.default)("numberSelectorOptionExcept", 
                // eslint-disable-next-line eqeqeq
                value != null && naValue == value && "active"), onClick: (e) => {
                    var _a, _b;
                    // eslint-disable-next-line eqeqeq
                    onChange(naValue != value ? naValue : null);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                }, onMouseDown: (e) => e.preventDefault() }, s(naTitle)))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }, [naTitle, naValue, value, onChange, s]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState }, uiType === "slider" ? (react_1.default.createElement(slider_1.Slider, { options: options, onChange: sliderOnChange, value: sliderValue, hasError: fieldState.invalid, showMiddleLabel: true, naTitles: [naTitle], naValues: [naValue], valueIncludeNA: value }, NotApplicableComponent)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "selector-horizontal" },
            react_1.default.createElement("div", { style: {
                    display: "table",
                }, className: (0, classnames_1.default)({
                    "has-error": fieldState.invalid,
                }) },
                textBefore && (react_1.default.createElement("div", { className: "text", style: { textAlign: "left" } }, s(textBefore))),
                react_1.default.createElement("div", null, list.map((optionValue) => (react_1.default.createElement("span", { key: optionValue, className: (0, classnames_1.default)("numberSelectorOption", value != null &&
                        // eslint-disable-next-line eqeqeq
                        value != naValue &&
                        optionValue <= value &&
                        "active"), onClick: (e) => {
                        var _a, _b;
                        onChange(optionValue !== value ? optionValue : null);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }, onMouseDown: (e) => e.preventDefault() }, optionValue)))),
                textAfter && (react_1.default.createElement("div", { className: "text", style: { textAlign: "right" } }, s(textAfter))))),
        NotApplicableComponent))));
};
NumberSelectorSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("NumberSelectorDisplayComponent");
exports.default = NumberSelectorSchemaComponent;
